import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CalculatorFrameWrapperComponent } from './calculator-frame-wrapper/calculator-frame-wrapper.component';

const routes: Routes = [
  {
    path: '',
    component: CalculatorFrameWrapperComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CalculatorFrameRoutingModule {
}
